__webpack_require__.f.compat = (chunkId, promises) => {

	const originalLoadChunk = __webpack_require__.l;
	__webpack_require__.l = (url, done, key, chunkId) => flarum.reg.loadChunk(originalLoadChunk, url, done, key, chunkId, "fof-seo");
};